RivalIQ.module('extensions.underscore.string', function (module, App, Backbone, Marionette, $, _, s) {

    'use strict';

    s.centerTruncate = function (str, length, truncateStr) {
        length = ~~length; // null becomes 0
        if (str.length <= length) {
            return str;
        }

        return s.truncate(str, length / 2, truncateStr) + str.slice(str.length - length / 2, str.length);
    };
}, window.s);
